/**
 * The User UI's translation namespaces, registered into common's i18n runtime
 * at start-up through `registerTranslations`, exactly as Admin does
 * (i18n in packages/admin/README.md).
 *
 * One `<domain>.ts` per screen domain, exporting a `TranslationBundle` (a tree
 * per supported locale, identical keys), and one line in `USER_NAMESPACES`.
 * Words the kit or several screens share, and the GRMS and housekeeping
 * surfaces, stay in common's tables (`kit`, `common`, `nav`, `grms`,
 * `housekeeping`); a namespace here never reuses one of common's top-level
 * names, because registration deep-merges into them.
 */
import { registerTranslations, type TranslationBundle } from '@bms/common';
import { cardDesk } from './cardDesk';
import { reports } from './reports';
import { shell } from './shell';
import { controls } from './controls';
import { visitors } from './visitors';
import { hotelSettings } from './hotelSettings';
import { checkIn } from './checkIn';
import { search } from './search';
import { activity } from './activity';

export const USER_NAMESPACES: Readonly<Record<string, TranslationBundle>> = {
  cardDesk,
  reports,
  shell,
  controls,
  visitors,
  hotelSettings,
  checkIn,
  search,
  activity,
};

/** Register every User namespace once; safe to call again (a hot reload). */
export function registerUserTranslations(): void {
  for (const [namespace, bundle] of Object.entries(USER_NAMESPACES)) {
    registerTranslations(namespace, bundle);
  }
}
